<template>
  <!-- macOS-style Menu Bar -->
  <nav class="menu-bar" :class="{ 'menu-hidden': isMobile && isMenuHidden }">
    <!-- Title on the left -->
    <div class="menu-title">{{ getComponentTitle(currentComponent) }}</div>

    <!-- Icons on the right -->
    <div class="menu-items">
      <!-- Home (last in HTML = first on right with row-reverse) -->
      <button
        @click="$emit('change-component', 'Home')"
        :class="{ active: currentComponent === 'Home' }"
        class="menu-icon-btn"
        title="Home"
      >
        🏠
      </button>

      <!-- Divider -->
      <div class="menu-divider"></div>

      <!-- LinkedIn -->
      <a
        href="https://www.linkedin.com/in/aleksandergolubev/"
        target="_blank"
        rel="noopener noreferrer"
        class="menu-icon-btn"
        title="LinkedIn"
      >
        💼
      </a>

      <!-- Family -->
      <button
        @click="$emit('change-component', 'Family')"
        :class="{ active: currentComponent === 'Family' }"
        class="menu-icon-btn"
        title="Family"
      >
        👨‍👩‍👧‍👦
      </button>

      <!-- Playground -->
      <button
        @click="$emit('change-component', 'Playground')"
        :class="{ active: currentComponent === 'Playground' }"
        class="menu-icon-btn"
        title="Playground"
      >
        🎮
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    currentComponent: {
      type: String,
      required: true
    },
    isMenuHidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 768
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    getComponentTitle(component) {
      const titles = {
        'Home': 'Home',
        'Family': 'Family',
        'Playground': 'Playground',
        'ClickingGame': 'Clicking Game',
        'SnakeGame': 'Snake Game',
        'ChessGame': 'Chess Game'
      }
      return titles[component] || component
    }
  }
}
</script>

<style scoped>
/* macOS-style Menu Bar */
.menu-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 44px;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  transition: transform 0.3s ease-out;
}

.menu-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  letter-spacing: -0.5px;
  flex: 1;
  text-align: left;
}

.menu-items {
  display: flex;
  flex-direction: row-reverse;
  gap: 20px;
  margin-left: auto;
  align-items: center;
}

.menu-icon-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  opacity: 0.7;
  filter: grayscale(40%);
  text-decoration: none;
}

.menu-icon-btn:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.06);
  filter: grayscale(20%);
}

.menu-icon-btn.active {
  opacity: 1;
  background-color: rgba(76, 175, 80, 0.15);
  filter: grayscale(0%);
}

.menu-icon-btn.active:hover {
  background-color: rgba(76, 175, 80, 0.2);
}

.menu-divider {
  width: 1px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.2);
  margin: 0 4px;
}

.menu-hidden {
  transform: translateY(-100%);
}

@media (max-width: 768px) {
  .menu-bar {
    height: 44px;
  }

  .menu-items {
    gap: 16px;
  }

  .menu-icon-btn {
    font-size: 16px;
    width: 28px;
    height: 28px;
  }
}
</style>
